import { render, staticRenderFns } from "./dialog-from.vue?vue&type=template&id=8b399b74&"
import script from "./dialog-from.vue?vue&type=script&lang=js&"
export * from "./dialog-from.vue?vue&type=script&lang=js&"
import style0 from "./dialog-from.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports